import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { publicKey: String, declineUrl: String }

  async connect() {
    if (!('serviceWorker' in navigator) || !('PushManager' in window) || !('Notification' in window)) return
    if (Notification.permission === 'denied') return

    if (Notification.permission === 'granted') {
      const reg = await navigator.serviceWorker.ready
      const existing = await reg.pushManager.getSubscription()
      if (existing) return
    }

    this.element.classList.remove('d-none')
  }

  async subscribe() {
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) return

    const reg = await navigator.serviceWorker.ready
    const existing = await reg.pushManager.getSubscription()
    if (existing) { this.dismiss(); return }

    const permission = await Notification.requestPermission()
    if (permission !== 'granted') { this.dismiss(); return }

    const sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: this.#urlBase64ToUint8Array(this.publicKeyValue)
    })

    const json = sub.toJSON()
    await fetch('/subscription', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': document.querySelector('meta[name=csrf-token]').content },
      body: JSON.stringify({ endpoint: json.endpoint, p256dh: json.keys.p256dh, auth: json.keys.auth })
    })

    this.dismiss()
  }

  async decline() {
    await fetch(this.declineUrlValue, {
      method: 'PATCH',
      headers: { 'X-CSRF-Token': document.querySelector('meta[name=csrf-token]').content, 'Accept': 'text/vnd.turbo-stream.html' }
    })
    this.element.remove()
  }

  dismiss() {
    this.element.remove()
  }

  #urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4)
    const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/')
    const rawData = atob(base64)
    return Uint8Array.from([...rawData].map(c => c.charCodeAt(0)))
  }
}
